import gql from 'graphql-tag';

import { JobInvoiceableInbox } from './jobInvoiceInbox';
import { JobInvoiceableDeferredInbox } from './jobInvoiceableDeferredInbox';
import { querySelector, nextId } from '../../../utils';
import { TicketsOnJobGQL } from './ticketsOnJob';

/*
* input: TicketUndeferJob!
*   id: Int!
*/
const JobUndefer = gql`
  mutation TicketUndeferJob($input: TicketUndeferJobInput!) {
    ticket_undefer_job(input: $input)
  }
`;


const jobUndeferApi = async (client, ticketId, jobId) => {
  const variables = {
    input: {
      id: ticketId,
    },
  };

  const options = {
    mutation: JobUndefer,
    variables,
    refetchQueries: [
      { query: JobInvoiceableInbox },
      { query: JobInvoiceableDeferredInbox },
    ],
  };

  /*
* Read old invoiceable jobs from cache before calling server mutation. Many clients to this
* function are concerned with the state of the collection during the update process.
* TODO: How to deduplicate query selector? Its is copied straight from jobInvoiceInbox
 */
  const cachedQueryResults = client.readQuery({ query: JobInvoiceableDeferredInbox });
  const oldCollection = querySelector(cachedQueryResults, '$.jobs_for_approval_inbox.edges[*].node', []);
  const result = await client.mutate(options);

  /*
  Grab the tickets that should now be displayed. If the month lease was destroyed this
  will grab the new month lease's tickets. If the month lease was not destroyed the tickets
  will exclude all the tickets on the job that was just undeferred.
  */
  const { ticket_undefer_job: monthLeaseInvoiceDestroyed } = result.data;

  let nJobId = jobId;
  if (monthLeaseInvoiceDestroyed) {
    nJobId = nextId(oldCollection, jobId);
  }

  // If we have no more month lease invoices mliId will be undefined.
  if (nJobId) {
    client.query({
      query: TicketsOnJobGQL,
      variables: { jobId: nJobId },
      fetchPolicy: 'network-only',
    });
  }

  return {
    oldCollection,
    result,
  };
};


export default jobUndeferApi;
